"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIAbstractIconDropdown = _interopRequireDefault(require("./abstract/UIAbstractIconDropdown"));

var _SimpleStyledClickable = _interopRequireDefault(require("./internal/SimpleStyledClickable"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UITextToolbarIcon = _interopRequireDefault(require("../editor/UITextToolbarIcon"));

var _OptionTypes = require("../types/OptionTypes");

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var UITextToolbarIconDropdown =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UITextToolbarIconDropdown, _Component);

  function UITextToolbarIconDropdown() {
    (0, _classCallCheck2.default)(this, UITextToolbarIconDropdown);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextToolbarIconDropdown).apply(this, arguments));
  }

  (0, _createClass2.default)(UITextToolbarIconDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          options = _this$props.options,
          placement = _this$props.placement,
          tooltip = _this$props.tooltip,
          currentValue = _this$props.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["open", "options", "placement", "tooltip", "value"]);
      var selectedOption = options.find(function (_ref) {
        var value = _ref.value;
        return value === currentValue;
      });
      var renderedIcon = selectedOption ? _react.default.createElement(_UITextToolbarIcon.default, {
        name: selectedOption.icon
      }) : null;
      return _react.default.createElement(_UITooltip.default, {
        open: open ? false : undefined,
        placement: placement,
        title: tooltip
      }, _react.default.createElement(_UIAbstractIconDropdown.default, (0, _extends2.default)({
        Button: _SimpleStyledClickable.default,
        buttonText: renderedIcon,
        open: open,
        options: options,
        value: currentValue
      }, rest)));
    }
  }]);
  return UITextToolbarIconDropdown;
}(_react.Component);

UITextToolbarIconDropdown.propTypes = {
  defaultValue: _OptionTypes.SingleValueType,
  onChange: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool.isRequired,
  options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    icon: _UITextToolbarIcon.default.propTypes.name,
    value: _OptionTypes.SingleValueType
  }).isRequired).isRequired,
  placement: _UITooltip.default.propTypes.placement,
  tooltip: _UITooltip.default.propTypes.title,
  value: _OptionTypes.SingleValueType
};
UITextToolbarIconDropdown.defaultProps = {
  open: false,
  placement: 'bottom'
};
UITextToolbarIconDropdown.displayName = 'UITextToolbarIconDropdown';

var _default = (0, _Controllable.default)(UITextToolbarIconDropdown, ['open', 'value']);

exports.default = _default;
module.exports = exports.default;